import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { CLIENT_STATUS_UNSUPPORTED } from '../../../../clients/constants';
import { clientShape } from '../../../../clients/propTypes';
import {
  Item,
  Icon,
  Text,
  Label,
  SubLabel,
  Flag
} from './styled';

const ClientRailItem = forwardRef(({ client, isActive = false, onSelect }, ref) => {
  const intl = useIntl();

  const {
    id,
    label,
    subLabel,
    icon: IconComponent,
    status
  } = client;

  return (
    <Item
      $active={ isActive }
      aria-controls={ `mcp-client-panel-${id}` }
      aria-selected={ isActive }
      id={ `mcp-client-tab-${id}` }
      onClick={ () => onSelect(id) }
      ref={ ref }
      role="tab"
      tabIndex={ isActive ? 0 : -1 }
      type="button"
    >
      {IconComponent && <Icon $active={ isActive }><IconComponent /></Icon>}
      <Text>
        <Label $active={ isActive }>{label}</Label>
        {subLabel && <SubLabel>{subLabel}</SubLabel>}
      </Text>
      {status === CLIENT_STATUS_UNSUPPORTED && (
        <Flag title={ intl.formatMessage({ id: 'mcp.status.unsupported' }) } />
      )}
    </Item>
  );
});

ClientRailItem.displayName = 'ClientRailItem';

ClientRailItem.propTypes = {
  client: clientShape.isRequired,
  isActive: PropTypes.bool,
  onSelect: PropTypes.func.isRequired
};

export default ClientRailItem;
